import { render, staticRenderFns } from "./WhiteRow.vue?vue&type=template&id=15c88050&scoped=true&"
import script from "./WhiteRow.vue?vue&type=script&lang=js&"
export * from "./WhiteRow.vue?vue&type=script&lang=js&"
import style0 from "./WhiteRow.vue?vue&type=style&index=0&id=15c88050&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c88050",
  null
  
)

export default component.exports